import {type Permission} from '@hconnect/apiclient'
import {NavItem} from '@hconnect/uikit/src/lib2'
import {useTranslation} from 'react-i18next'

import {useGetHrocLinks, useRcfaComplianceNavItem} from '../../hroc/routing'
import {useGetPerformanceDashboardLinks} from '../../performanceDashboard/routing'
import {HROC_PREFIX} from '../consts'

import {useTasksLinks} from './useTasksLinks'

const MIN_NAV_ITEMS_FOR_GROUPING = 5

export const useGetLinks = ({permissions}: {permissions: Permission[]}): NavItem[] => {
  const {t} = useTranslation()

  const [expertSystemUsageRateLink, ...restPerformanceDashboardLinks] =
    useGetPerformanceDashboardLinks({permissions})
  const tasksLinks = useTasksLinks()
  const hrocLinks = useGetHrocLinks({permissions})
  const rcfaComplianceLink = useRcfaComplianceNavItem({permissions})

  const allLinks = [
    ...restPerformanceDashboardLinks,
    ...(rcfaComplianceLink ? [rcfaComplianceLink] : []),
    expertSystemUsageRateLink,
    ...tasksLinks,
    ...hrocLinks
  ]

  if (allLinks.length > MIN_NAV_ITEMS_FOR_GROUPING) {
    const groupedLinks = [
      {
        url: '_no-url_', // no common base URL for grouped links as they are dynamic
        label: t(`${HROC_PREFIX}.navPages.more`),
        subItems: allLinks.slice(MIN_NAV_ITEMS_FOR_GROUPING - 1),
        isDisabled: true, // we do not provide a page for the main HROC nav item
        dataTestId: 'hroc-nav-item'
      }
    ]
    return [...allLinks.slice(0, MIN_NAV_ITEMS_FOR_GROUPING - 1), ...groupedLinks]
  }

  return allLinks
}
